/**
 * Recently Viewed tracker (GFTY-5084)
 * Client-side only, localStorage-backed. No backend/Algolia involved.
 *
 * Usage:
 *   window.GiftoryRecentlyViewed.track({ id, handle, title, product_type, available, images,
 *     variants_count, price, compare_at_price, meta: { custom: {...} } });
 *   see snippets/recently-viewed-tracker.liquid for the exact payload shape.
 *   window.GiftoryRecentlyViewed.getRecent(excludeId, limit) -> array, most recently viewed first
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'giftory_recently_viewed';
  var MAX_STORED = 15;

  function getList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) {
        console.warn('[RVC] stored value was not an array, resetting', list);
        return [];
      }
      return list;
    } catch (e) {
      console.error('[RVC] getList() JSON.parse failed — treating as empty', e);
      return [];
    }
  }

  function track(product) {
    if (!product || product.id == null) {
      console.warn('[RVC] track() called with invalid product, skipping', product);
      return;
    }
    try {
      var list = getList().filter(function (p) {
        return String(p.id) !== String(product.id);
      });
      list.unshift(product);
      if (list.length > MAX_STORED) list = list.slice(0, MAX_STORED);

      var serialized = JSON.stringify(list);
      // Belt-and-braces: JSON.stringify on a plain object can't normally produce invalid JSON, but a
      // prior corrupted write silently emptied every read for days before surfacing on an unrelated
      // page. Round-trip it before committing so a bad write is caught — and the culprit product
      // logged — right here, instead of surfacing later as an unexplained empty carousel elsewhere.
      try {
        JSON.parse(serialized);
      } catch (roundTripErr) {
        console.error('[RVC] track() produced unparseable JSON — write aborted to avoid corrupting storage', roundTripErr, 'product was:', product);
        return;
      }

      localStorage.setItem(STORAGE_KEY, serialized);
      console.log('[RVC] tracked product', product.id, '— stored count now', list.length);
    } catch (e) {
      // localStorage unavailable (private mode / quota) — fail silently, tracking is best-effort
      console.error('[RVC] track() failed to write to localStorage', e);
    }
  }

  function getRecent(excludeId, limit) {
    var list = getList();
    if (excludeId != null) {
      list = list.filter(function (p) {
        return String(p.id) !== String(excludeId);
      });
    }
    var result = typeof limit === 'number' ? list.slice(0, limit) : list;
    console.log('[RVC] getRecent(', excludeId, ',', limit, ') ->', result.length, 'of', list.length, 'stored');
    return result;
  }

  window.GiftoryRecentlyViewed = { track: track, getRecent: getRecent };
  console.log('[RVC] recently-viewed.js loaded, window.GiftoryRecentlyViewed ready');
})();
